import "./CustomerService.module.css";
import Header from "@/reusable_sections/Header";
import Shipping from "./sections/Shipping";
import Sizing from "./sections/Sizing";
import Faq from "./sections/Faq";
import Concierge from "./sections/Concierge";
import Footer from "@/reusable_sections/Footer";
export default function CustomerservicePage() {
  return <div>
      <Header />
      <Shipping />
      <Sizing />
      <Faq />
      <Concierge />
      <Footer />
    </div>;
}